<template>
  <div class="animate-pulse">
    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-3 rounded-t-lg bg-[#F0F0F4]">
      <div class="h-4 w-64 bg-slate-200 rounded"></div>
      <div class="flex items-center gap-2">
        <div class="h-8 w-[112px] bg-slate-200 rounded"></div>
        <div class="h-8 w-[135px] bg-slate-200 rounded"></div>
      </div>
    </div>

    <!-- Rule rows -->
    <div class="p-4 rounded-b-lg border border-t-0 border-neutralLight">
      <div
        v-for="n in 3"
        :key="n"
        class="flex items-center gap-3 px-3 h-16 rounded-lg border border-neutralLight bg-[#F0F0F4] mb-2 last:mb-0"
      >
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
        <div class="h-4 w-24 bg-slate-200 rounded"></div>
        <div class="h-10 w-[250px] bg-slate-200 rounded"></div>
        <div class="ml-auto h-6 w-6 bg-slate-200 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
